import React from 'react';
import { SHOW_MORE_BUTTON } from '@/constants/test-ids';
import styles from './ShowMoreButton.module.scss';

export type ShowMoreButtonProps = {
  onClick: F<React.MouseEvent>;
};

export const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({ onClick }) => (
  <button
    className={styles.showMoreBtn}
    onClick={onClick}
    data-test-id={SHOW_MORE_BUTTON}
  >
    Show more
  </button>
);
